<template>
  <v-dialog v-model="state" width="800">
    <v-card>
      <v-card-title primary-title>Cơ sở: {{data.department.title}}</v-card-title>

      <div class="d-flex flex-row">
        <div class="flex-grow-1">
          <v-card-text>{{ "Phụ huynh: " + data.parentName}}</v-card-text>
          <v-card-text>{{ "Học viên: " + data.name}}</v-card-text>
          <v-card-text>{{ "Tuổi/Lớp: " + data.age}}</v-card-text>
          <v-card-text>{{ "Địa chỉ: " + data.address}}</v-card-text>
        </div>
        <div class="flex-grow-1">
          <v-card-text>{{ "Nguời xử lý: " + data.assignee.name}}</v-card-text>
          <v-card-text>{{ "Ngày Onboard: " + data.onboard}}</v-card-text>
          <v-card-text>{{ "Ngày xử lý gần nhất: " + data.handledDate}}</v-card-text>
          <v-card-text>{{ "Nguồn: " + data.provider}}</v-card-text>
        </div>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    contact: { type: [Object] },
    disabled: { type: [Boolean], required: false, default: () => true },
    dialog: { type: [Boolean], required: false, default: () => false }
  },
  data () {
    return {
      state: false
    }
  },
  methods: {
    closeDialog () {
      this.state = false
    }
  },
  computed: {
    data () {
      return this.contact.department
        ? this.contact
        : { department: {}, assignee: {} }
    }
  },
  watch: {
    dialog (dialog) {
      this.state = true
    }
  }
}
</script>

<style scoped>
</style>
